import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ApiUtil from "../api/ApiUtil";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

const MenuBarSetting = () => {
  const [loading, setLoading] = useState(false);
  const [menuSetting, setMenuSetting] = useState([]);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    pageInitializationSetting();
  }, []);

  const pageInitializationSetting = async () => {
    setLoading(true);

    try {
      const response = await ApiUtil.SendAsync({
        url: "/settings/menu-order",
        method: "GET",
      });

      if (response.status == 200) {
        setMenuSetting(response?.data?.data.setting);
      }
    } catch (error) {
      toast.error("Error fetching menu Setting!");
    }
    setLoading(false);
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const reorderedMenuSetting = Array.from(menuSetting);
    const [movedItem] = reorderedMenuSetting.splice(result.source.index, 1);
    reorderedMenuSetting.splice(result.destination.index, 0, movedItem);

    setMenuSetting(reorderedMenuSetting);
  };

  const onSaveHandler = async () => {
    setUpdating(true);
    try {
      const response = await ApiUtil.SendAsync({
        url: "/settings/save-menu-items-order",
        method: "POST",
        data: JSON.stringify({
          name: "menu-order",
          setting: menuSetting,
        }),
      });

      if (response.status == 200) {
        setMenuSetting(response?.data?.data.setting);
      }

      toast.success("Menu Settings updated!");
    } catch (error) {
      toast.error("Error Updating Menu Setting!");
    }
    setUpdating(false);
  };

  return (
    <div style={{ width: "300px", margin: "auto", textAlign: "center" }}>
      <h1 style={{ fontSize: "20px", fontWeight: "500" }}>Menu Setting</h1>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="menuSetting">
          {(provided) => (
            <ul
              {...provided.droppableProps}
              ref={provided.innerRef}
              style={{ listStyle: "none", padding: 0 }}
            >
              {menuSetting.map((menu, index) => (
                <Draggable
                  key={menu.slug}
                  draggableId={menu.slug}
                  index={index}
                >
                  {(provided) => (
                    <li
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={{
                        padding: "10px",
                        margin: "5px 0",
                        backgroundColor: "#f0f0f0",
                        cursor: "grab",
                        borderRadius: "5px",
                        ...provided.draggableProps.style,
                      }}
                    >
                      {menu.name}
                    </li>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </ul>
          )}
        </Droppable>
      </DragDropContext>
      <button
        onClick={onSaveHandler}
        style={{
          marginTop: "10px",
          padding: "8px 15px",
          background: "rgb(230, 121, 41)",
          borderRadius: "5px",
        }}
        disabled={updating}
      >
        {updating ? "Updating.." : "Update Settings"}
      </button>
    </div>
  );
};

export default MenuBarSetting;
